const Logo = require("../../../assets/logo.png");
const premiumLogo = require("../../../assets/premiumlogo.png");
export const DplusLogo = ({ className, alt, isPremium }) => isPremium ? (React.createElement("img", { className: className, src: premiumLogo, alt: alt })) : (React.createElement("img", { className: className, src: Logo, alt: alt }));

